/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import dayjs from 'dayjs';

import { ColumnTexts } from '../../enums';

const normalizeOldDateFormat = (format: string) => {
    const replacePatterns = {
        tt: 'A',
        yy: 'YY',
        d: 'D',
    };

    return format.replace(/tt|yy|d/g, s => replacePatterns[s]);
};

const isDate = (value: string | number | Date | null): boolean => Object.prototype.toString.call(value) === '[object Date]';

const formatDate = (date: Date, format: string): string => dayjs(date).format(format);

const renderShortDateAndTimeForColumn = (
    value: string | number | Date | null,
    shortDate: string,
    shortTime: string,
    excludeTimeShiftCorrection = false,
): string => {
    if (!isDate(value)) {
        value = new Date(Date.parse(value as string));
    }

    if (!isDate(value) || Number.isNaN((value as Date).getTime()) || value <= new Date(0)) {
        return ColumnTexts.DashSymbol;
    }

    if (excludeTimeShiftCorrection) {
        (value as Date).setMinutes((value as Date).getMinutes() + (value as Date).getTimezoneOffset());
    }

    return formatDate(value as Date, `${normalizeOldDateFormat(shortDate)} ${normalizeOldDateFormat(shortTime)}`);
};

export {
    normalizeOldDateFormat,
    isDate,
    formatDate,
    renderShortDateAndTimeForColumn,
};
